import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CoreService } from '@app/shared/models/clux/enum';
import { Uri } from '@app/shared/utils/uri';
import { ContactQuery } from '@app/state';
import { ChainType, Criteria, MatchType } from '@models/configuration/model';
import { ClientAccountSummary } from '@models/dashboard/model';
import { ClientCauseState } from '@models/giving/model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientAccountQuery {
  private readonly contactQuery = inject(ContactQuery);
  private readonly http = inject(HttpClient);

  public fetchSummary$(query: SearchQuery = { orderBy: 'startDate', orderDirection: 'desc' }): Observable<ClientAccountSummary[]> {
    const clientId = this.contactQuery.getActive().clientId;
    const criteria: Criteria[] = [
      {
        key: 'clientId',
        value: clientId,
        matchType: MatchType.EXACT,
        chainType: ChainType.AND,
      },
      {
        key: 'currentState',
        value: [ClientCauseState.Active, ClientCauseState.Inactive].join('|'),
        matchType: MatchType.IN,
        chainType: ChainType.AND,
      },
    ];

    const url = new Uri(`/profile/${clientId}/clientAccountSummary/search`, CoreService.Dashboard);
    return this.http.post<ClientAccountSummary[]>(url.toString(), criteria, { params: query });
  }
}

interface StringMap {
  [key: string]: string;
}
interface SearchQuery extends StringMap {
  take?: string;
  skip?: string;
  orderBy?: string;
  orderDirection?: string;
}
